import { Component, Input } from '@angular/core';

export const INFORMATION_PDIALOG_KEY = 'informationDialogKey';

@Component( {
    selector: 'erp-information-dialog',
    templateUrl: './information-dialog.component.html'
} )

export class InformationDialogComponent {
    @Input() width = 850;
    @Input() header = 'rm.erp.common.confirmation.warn';
    @Input() key = INFORMATION_PDIALOG_KEY;
}
